import React, { Component } from 'react';
import './legandCheckbox.scss';
import { Checkbox } from 'antd';

class LegandCheckbox extends Component {
  state = {};

  render() {
    const getCheckBoxClassName = (colour) => {
      switch (colour) {
        case '#d0908c': {
          return 'cviz-graph-checkboxes--1';
        }
        case '#602c17': {
          return 'cviz-graph-checkboxes--2';
        }
        case '#d5b758': {
          return 'cviz-graph-checkboxes--3';
        }
        case '#594a17': {
          return 'cviz-graph-checkboxes--4';
        }
        case '#a5cfa0': {
          return 'cviz-graph-checkboxes--5';
        }
        case '#626262': {
          return 'cviz-graph-checkboxes--6';
        }
        case '#96B8E9': {
          return 'cviz-graph-checkboxes--7';
        }
        case '#4F8D47': {
          return 'cviz-graph-checkboxes--8';
        }
        case '#49A7A2': {
          return 'cviz-graph-checkboxes--9';
        }
        case '#7FA0CF': {
          return 'cviz-graph-checkboxes--10';
        }
        case '#52637C': {
          return 'cviz-graph-checkboxes--11';
        }
        case '#263449': {
          return 'cviz-graph-checkboxes--12';
        }
        case '#1080A6': {
          return 'cviz-graph-checkboxes--14';
        }
        case '#96b8e9': {
          return 'cviz-graph-checkboxes--13';
        }
        case '#999999': {
          return 'cviz-graph-checkboxes--15';
        }
        case '#BACDE9': {
          return 'cviz-graph-checkboxes--16';
        }
        case '#7B9BCA': {
          return 'cviz-graph-checkboxes--17';
        }
        case "#172437": {
          return 'cviz-graph-checkboxes--18';
        }
        case '#D0908C': {
          return 'cviz-graph-checkboxes--19';
        }
        case '#64413F': {
          return 'cviz-graph-checkboxes--20';
        }
        case '#A5CFA0': {
          return 'cviz-graph-checkboxes--21';
        }
        default: {
          return 'cviz-graph-checkboxes--1';
        }
      }
    };
    return (
      <ul className="cviz-graph-checkboxes">
        {this.props.series.map((item, key) => {
          return (
            <li key={key}>
              <Checkbox
                defaultChecked={true}
                onClick={() => this.props.toggle(item.name)}
                className={
                  'cviz-graph-checkboxes--checkbox ' +
                  getCheckBoxClassName(this.props.colours[key])
                }
              >
                <span
                  className="cviz-graph-checkboxes--title"
                  dangerouslySetInnerHTML={{
                    __html: this.props.series[key].name,
                  }}
                />
              </Checkbox>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default LegandCheckbox;
